var React = require('react');

function IconCircleStar (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_555_962)","key":0},[React.createElement("circle",{"cx":"20","cy":"20","r":"18","stroke":"#142B6F","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20 9L23.1035 15.7284L30.4616 16.6008L25.0216 21.6316L26.4656 28.8992L20 25.28L13.5344 28.8992L14.9784 21.6316L9.53838 16.6008L16.8965 15.7284L20 9Z","stroke":"#142B6F","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_555_962"},React.createElement("rect",{"width":"40","height":"40","fill":"white"})))]);
}

IconCircleStar.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IconCircleStar;

IconCircleStar.default = IconCircleStar;
